(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousels() {
    document.querySelectorAll('.collection--carousel').forEach(function (section) {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = '1';

      var scroll = section.querySelector('.collection__carousel-scroll');
      var btnPrev = section.querySelector('.collection__carousel-btn--prev');
      var btnNext = section.querySelector('.collection__carousel-btn--next');
      if (!scroll) return;

      function getItemStep() {
        var first = scroll.querySelector('.collection__carousel-item');
        var gap = parseFloat(getComputedStyle(scroll).gap) || 35;
        return first ? first.offsetWidth + gap : 280 + gap;
      }

      if (btnPrev) {
        btnPrev.addEventListener('click', function () {
          scroll.scrollBy({ left: -getItemStep(), behavior: 'smooth' });
        });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function () {
          scroll.scrollBy({ left: getItemStep(), behavior: 'smooth' });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
